import UsageTracker from 'products-highlight-card-lib/utils/UsageTracker';
export const ProductsTracker = UsageTracker.clone({
  properties: {
    namespace: 'products'
  }
});